module.exports = __webpack_public_path__ + "img/currencyBack2.ac5160ed.png";